import { useEffect, useState } from "react";
import { api } from "@/api/client";

// FIX B (2026-02): profile photos were stored as raw Google Drive links (webViewLink/
// webContentLink) — neither is directly embeddable in an <img src>, since almost no viewer of
// a photo (own portal, staff directory, community members list) is a Shared Drive member; the
// link just 403s/404s and renders a broken-image icon everywhere the photo appears. Same fix as
// community/PostAttachment.jsx: proxy the actual bytes through our own authenticated API
// (GET /v1/build/freelancers/{id}/profile-image) as a blob (works for both cookie- and
// Bearer-token sessions, unlike a bare <img src="...">), never the raw Drive link.
//
// `hasPhoto` lets the caller skip the fetch entirely (and just render its own `fallback`) when
// there's no photo at all — every call site already knows this from `Boolean(f.profile_image)`.
export function ProfileAvatar({ freelancerId, hasPhoto, alt, className, testId, fallback }) {
  const [objectUrl, setObjectUrl] = useState(null);

  useEffect(() => {
    if (!hasPhoto || !freelancerId) { setObjectUrl(null); return; }
    let url;
    let active = true;
    api.get(`/v1/build/freelancers/${freelancerId}/profile-image`, { responseType: "blob" }).then((r) => {
      if (!active) return;
      // A 204 (no photo yet) resolves as a 0-byte blob, not an error — treat it the same as
      // "no image" instead of creating an object URL for an empty blob (broken-image icon).
      if (!r.data || r.data.size === 0) { setObjectUrl(null); return; }
      url = window.URL.createObjectURL(r.data);
      setObjectUrl(url);
    }).catch(() => { if (active) setObjectUrl(null); });
    return () => { active = false; if (url) window.URL.revokeObjectURL(url); };
  }, [freelancerId, hasPhoto]);

  if (objectUrl) return <img src={objectUrl} alt={alt || ""} className={className} data-testid={testId} loading="lazy" decoding="async" />;
  return fallback ?? null;
}
